<template>
  <v-list-tile v-if="!isEditing" avatar class="it-hv">
    <v-list-tile-avatar>
      <font-awesome-icon :icon="['fal', 'plane']"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-sub-title class="caption" v-if="isStatusDone">
        <span class="font-weight-bold" v-if="!isTypeEmpty">渡航目的：</span>{{ printType }}
      </v-list-tile-sub-title>
      <v-list-tile-title v-if="isStatusDone">{{ printCountry }}{{ printCity }}</v-list-tile-title>
      <v-list-tile-sub-title class="caption" v-if="isStatusDone">
        <span class="font-weight-bold">渡航日：</span>{{ printDepartDate }}
        <span class="font-weight-bold">期間：</span>{{ printTerm }}
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-menu offset-y>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading || isLoading"><v-icon>more_vert</v-icon></v-btn>
        <v-list>
          <v-list-tile @click="edit">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'pencil']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>編集する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="remove">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'trash-alt']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>削除する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-list-tile-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-tile>
  <v-container v-else>
    <v-layout wrap class="pb-4">
      <v-flex xs12 class="px-3" v-if="isFormStatusDone">
        <v-select
          v-model="form.country"
          label="渡航先の国"
          item-text="label"
          item-value="code"
          :rules="rules.country"
          :items="getNationItems"></v-select>
      </v-flex>
      <v-flex xs12 class="px-3" v-if="isFormStatusDone">
        <v-text-field
          v-model="form.city"
          label="都市"
          maxlength="50"></v-text-field>
      </v-flex>
      <v-flex xs12 class="px-3" v-if="isFormStatusDone">
        <v-select
          v-model="form.type"
          label="渡航目的"
          item-text="text"
          item-value="value"
          :rules="rules.type"
          :items="getTypeItems"></v-select>
      </v-flex>
      <v-flex xs12 class="px-3" v-if="isFormStatusDone">
        <v-text-field required
          v-model="printFormatedDepart"
          :rules="rules.depart"
          maxlength="30"
          append-icon="event"
          @click:append="datepick"
          label="渡航日"></v-text-field>
        <v-dialog v-model="config.datepicker.depart.status" max-width="290">
          <v-date-picker
            v-model="config.datepicker.depart.data"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="datepicked"></v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs12 class="px-3" v-if="isFormStatusDone">
        <v-text-field
          v-model="form.term"
          label="期間"
          maxlength="20"></v-text-field>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
export default {
  name: 'clientAboutBackgroundsTravel',
  components: {
    UtilConfirmModal
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'travel',
        status: {
          loading: false
        },
        datepicker: {
          depart: {
            data: '',
            status: false
          }
        }
      },
      form: {
        id: '',
        status: '',
        country: '',
        city: '',
        type: '',
        depart: '',
        term: '',
        note: ''
      },
      rules: {
        status: [
          v => !!v || '必須項目です'
        ],
        country: [
          v => !!v || '必須項目です'
        ],
        type: [
          v => !!v || '必須項目です'
        ],
        depart: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: '' + (dt.id ? dt.id : ''),
          status: dt.status ? dt.status : '',
          country: dt.country ? dt.country : '',
          city: dt.city ? dt.city : '',
          type: dt.type ? dt.type : '',
          depart: dt.depart ? dt.depart : '',
          term: dt.term ? dt.term : '',
          note: dt.note ? dt.note : ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          status: this.$props.data.status ? this.$props.data.status : '',
          country: this.$props.data.country ? this.$props.data.country : '',
          city: this.$props.data.city ? this.$props.data.city : '',
          type: this.$props.data.type ? this.$props.data.type : '',
          depart: this.$props.data.depart ? this.$props.data.depart : '',
          term: this.$props.data.term ? this.$props.data.term : '',
          note: this.$props.data.note ? this.$props.data.note : ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? ('travel_' + this.$props.data.id) : '',
          type: this.config.type
        }
      })
    },
    remove: function () {
      this.$refs.confirm.open({
        title: '渡航歴の削除',
        message: 'この渡航歴を削除してもよろしいですか？',
        callback: () => {
          this.$set(this.config.status, 'loading', true)
          this.axios.post(this.$url.api + 'user/about/delete/meta', {
            id: this.$props.data.id
          }, {
            headers: {
              'user-token': this.$localStorage.get('jwt')
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'remove',
                data: {
                  type: 'travels',
                  id: res.data.data.id ? res.data.data.id : ''
                }
              })
            }
          })
        }
      })
    },
    datepick: function () {
      if (this.form.depart.split('-').filter(it => isFinite(it)).length === 3) {
        this.$set(this.config.datepicker.depart, 'data', this.form.depart)
      }
      this.$set(this.config.datepicker.depart, 'status', true)
    },
    datepicked: function () {
      this.$set(this.form, 'depart', this.config.datepicker.depart.data)
      this.$set(this.config.datepicker.depart, 'status', false)
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === ('travel_' + this.$props.data.id))
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === ('travel_' + this.$props.data.id)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === ('travel_' + this.$props.data.id)
      )
    },
    printStatus () {
      return (
        this.$props.data &&
        this.$props.data.status &&
        this.$meta.visa.status[this.$props.data.status]
      ) ? this.$meta.visa.status[this.$props.data.status] : 'ビザ'
    },
    isStatusYes () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'YES'
      )
    },
    isStatusNo () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'NO'
      )
    },
    isStatusDone () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'DONE'
      )
    },
    isFormStatusYes () {
      return !!(
        this.form.status === 'YES'
      )
    },
    isFormStatusNo () {
      return !!(
        this.form.status === 'NO'
      )
    },
    isFormStatusDone () {
      return !!(
        this.form.status === 'DONE'
      )
    },
    printCountry () {
      return (
        this.$props.data &&
        this.$props.data.country &&
        this.$meta.nations[this.$props.data.country]
      ) ? this.$meta.nations[this.$props.data.country] : (this.$props.data.country === '?' ? '国は備考欄を参照' : '')
    },
    printCity () {
      return (
        this.$props.data &&
        this.$props.data.city
      ) ? ('（' + this.$props.data.city + '）') : ''
    },
    printType () {
      return (
        this.$props.data &&
        this.$props.data.type &&
        this.$meta.visa.types[this.$props.data.type]
      ) ? this.$meta.visa.types[this.$props.data.type] : ''
    },
    printDepartDate () {
      if (this.$props.data && this.$props.data.depart) {
        return (
          this.$props.data.depart.split('-').filter(it => isFinite(it)).length === 3
        ) ? this.$moment(this.$props.data.depart).format('YYYY/MM/DD') : this.$props.data.depart
      } else {
        return ''
      }
    },
    printFormatedDepart: {
      get: function () {
        if (this.form && this.form.depart) {
          return (
            this.form.depart.split('-').filter(it => isFinite(it)).length === 3
          ) ? this.$moment(this.form.depart).format('YYYY/MM/DD') : this.form.depart
        } else {
          return ''
        }
      },
      set: function (newValue) {
        this.$set(this.form, 'depart', newValue)
      }
    },
    printTerm () {
      return (
        this.$props.data && this.$props.data.term
      ) ? this.$props.data.term : ''
    },
    isStatusEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.status
      )
    },
    isTypeEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.type
      )
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.note
      ) ? this.$props.data.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data && this.$props.data.note
      )
    },
    getStatusItems () {
      return this.$meta.visa.status
    },
    getNationItems () {
      return Object.keys(this.$meta.nations).map(key => {
        return {
          code: key,
          label: this.$meta.nations[key]
        }
      }).concat([{
        code: '?',
        label: '該当する国がないので備考欄に入力する'
      }])
    },
    getTypeItems () {
      return Object.keys(this.$meta.visa.types).map(key => {
        return {
          value: key,
          text: this.$meta.visa.types[key]
        }
      })
    }
  }
}
</script>
